import { createSlice, createAction } from '@reduxjs/toolkit';
import { globalReset } from '@/store/actions';
import { VocabularyCategory, VocabularyCategoryResponse } from '@/services/vocabularyService';

// === CATEGORIES ACTIONS ===
export const fetchCategoriesRequest = createAction('categories/fetchCategoriesRequest');
export const fetchCategoriesSuccess = createAction<VocabularyCategoryResponse>('categories/fetchCategoriesSuccess');
export const fetchCategoriesFailure = createAction<string>('categories/fetchCategoriesFailure');

export const fetchVocabularyCategoriesRequest = createAction('categories/fetchVocabularyCategoriesRequest');
export const fetchVocabularyCategoriesSuccess = createAction<VocabularyCategoryResponse>(
    'categories/fetchVocabularyCategoriesSuccess',
);
export const fetchVocabularyCategoriesFailure = createAction<string>('categories/fetchVocabularyCategoriesFailure');

// === STATE INTERFACE ===
export interface CategoriesState {
    categories: VocabularyCategory[];

    // Loading States
    isLoading: boolean;

    // Error States
    error: string | null;
}

const initialState: CategoriesState = {
    categories: [],
    isLoading: false,
    error: null,
};

const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(globalReset, () => initialState)

            // === FETCH CATEGORIES ===
            .addCase(fetchCategoriesRequest, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchCategoriesSuccess, (state, action) => {
                state.isLoading = false;
                state.categories = action.payload.results;
            })
            .addCase(fetchCategoriesFailure, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            // === FETCH VOCABULARY CATEGORIES ===
            .addCase(fetchVocabularyCategoriesRequest, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchVocabularyCategoriesSuccess, (state, action) => {
                state.isLoading = false;
                state.categories = action.payload.results;
            })
            .addCase(fetchVocabularyCategoriesFailure, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export default categoriesSlice.reducer;
